import { render, staticRenderFns } from "./AdministradorList.vue?vue&type=template&id=5fdf58b8"
import script from "./AdministradorList.vue?vue&type=script&lang=js"
export * from "./AdministradorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports